<template>
  <el-dialog
    :visible.sync="codeShow"
    :close-on-click-modal="false"
    :show-close="false"
    :destroy-on-close="true"
    width="440px"
    append-to-body
    custom-class="codeDialog"
  >
    <!--图片区-->
    <div class="code-pic">
      <div class="code-wrap">
        <div class="code-bg">
          <img :src="imgSrc" alt="" >
          <canvas ref="puzzleBox" class="canvas1" width="365"
                  height="200" />
        </div>
        <div :style="`left:${dragParam.leftOrigin}px`" class="code-move">
          <div
            :style="`left:${dragParam.moveLeft}px;transition:${dragParam.ani}`"
            class="code-move-content"
          >
            <canvas
              ref="puzzleShadow"
              class="canvas2"
              width="365"
              height="200"
            />
            <canvas ref="puzzleLost" class="canvas3" width="365"
                    height="200" />
          </div>
        </div>
      </div>
    </div>
    <!--拖动区-->
    <div :class="{ codeError: dragParam.state == 2 }" class="code-bar">
      <div class="cb-text">按住滑块，拖动完成上方拼图</div>
      <div
        v-drag="dragParam"
        v-dragMove="dragParam"
        v-if="dragParam.state != 1"
        :style="`left:${dragParam.moveLeft}px;transition:${dragParam.ani}`"
        class="cb-btn"
      />
      <div
        :style="`width:${
          dragParam.state == 1 ? '100%' : dragParam.moveLeft + 2 + 'px'
        };transition:${dragParam.wAni}`"
        class="cb-state"
      >
        <span v-if="dragParam.state == 1">验证通过</span>
      </div>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
export default {
  directives: {
    drag(el, binding, vnode) {
      el.onmousedown = (e) => {
        let ox = e.pageX
        document.onmousemove = (em) => {
          let dx = em.pageX - ox
          if (dx > 0 && dx < 315) {
            binding.value.moveLeft = dx
            binding.value.ani = 'inherit'
            binding.value.wAni = 'inherit'
            binding.value.state = 0
          }
        }
        document.onmouseup = (eu) => {
          let d = eu.pageX - ox
          let verNum = -binding.value.leftOrigin
          let deviation = 4 // 偏移值
          let minLeft = verNum - deviation
          let maxLeft = verNum + deviation
          if (ox) {
            if (maxLeft > d && d > minLeft) {
              binding.value.state = 1
              vnode.context.$emit('success')
            } else {
              binding.value.state = 2
              setTimeout(() => {
                binding.value.moveLeft = 0
                binding.value.ani = 'left .5s'
                binding.value.wAni = 'width .5s'
              }, 100)
              setTimeout(() => {
                binding.value.state = 0
              }, 600)
            }
          }
          ox = 0
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    },
    dragMove(el, binding, vnode) {
      let touch, ox
      el.ontouchstart = (e) => {
        if (e.touches) {
          touch = e.touches[0]
        } else {
          touch = e
        }
        ox = touch.clientX
        el.ontouchmove = (em) => {
          if (em.touches) {
            touch = em.touches[0]
          } else {
            touch = em
          }
          let dx = touch.clientX - ox
          if (dx > 0 && dx < 315) {
            binding.value.moveLeft = dx
            binding.value.ani = 'inherit'
            binding.value.wAni = 'inherit'
            binding.value.state = 0
          }
        }
        el.ontouchend = (eu) => {
          if (eu.changedTouches) {
            touch = eu.changedTouches[0]
          } else {
            touch = eu
          }
          let d = touch.clientX - ox
          let verNum = -binding.value.leftOrigin
          let deviation = 4 // 偏移值
          let minLeft = verNum - deviation
          let maxLeft = verNum + deviation
          if (ox) {
            if (maxLeft > d && d > minLeft) {
              binding.value.state = 1
              vnode.context.$emit('success')
            } else {
              binding.value.state = 2
              setTimeout(() => {
                binding.value.moveLeft = 0
                binding.value.ani = 'left .5s'
                binding.value.wAni = 'width .5s'
              }, 100)
              setTimeout(() => {
                binding.value.state = 0
              }, 600)
            }
          }
          ox = 0
          e.preventDefault()
        }
      }
    }
  },
  props: {
    dialogShow: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      codeShow: false,
      imgSrc: '',
      dragParam: {
        leftOrigin: 0,
        ani: 'inherit',
        wAni: 'inherit',
        moveLeft: 0,
        state: 0
      }
    }
  },
  watch: {
    dialogShow(v) {
      this.codeShow = v
      if (v) {
        this.$nextTick(() => {
          this.init()
        })
      }
      !v &&
        setTimeout(() => {
          this.dragParam = {
            leftOrigin: 0,
            ani: 'inherit',
            wAni: 'inherit',
            moveLeft: 0,
            state: 0
          }
        })
    }
  },
  methods: {
    init() {
      let w = 365
      let h = 200
      let d = 15 // 缺块单位
      let imgLibrary = [
        '/static/assist/t1.jpg',
        '/static/assist/t2.jpg',
        '/static/assist/t3.jpg'
      ]
      let minX = 20 + 3 * d
      let maxX = w - 20 - 3 * d
      let minY = 10 + d
      let maxY = h - 10 - 3 * d

      let randomNum = (min, max) => {
        let r = max - min
        let rand = Math.random()
        if (Math.round(rand * r) === 0) {
          return min + 1
        } else {
          if (Math.round(rand * max) === max) {
            return max - 1
          } else {
            return min + Math.round(rand * r) - 1
          }
        }
      }

      let imgRandom = randomNum(1, imgLibrary.length)
      this.imgSrc = imgLibrary[imgRandom]
      let X = randomNum(minX, maxX)
      let Y = randomNum(minY, maxY)
      this.dragParam.leftOrigin = 10 - X

      let c = this.$refs.puzzleBox
      let ctx = c.getContext('2d')
      ctx.globalCompositeOperation = 'xor'
      ctx.shadowBlur = 10
      ctx.shadowColor = '#fff'
      ctx.shadowOffsetX = 3
      ctx.shadowOffsetY = 3
      ctx.fillStyle = 'rgba(0,0,0,.7)'
      ctx.beginPath()
      ctx.lineWidth = '1'
      ctx.strokeStyle = 'rgba(0,0,0,0)'
      ctx.moveTo(X, Y)
      ctx.lineTo(X + d, Y)
      ctx.bezierCurveTo(X + d, Y - d, X + 2 * d, Y - d, X + 2 * d, Y)
      ctx.lineTo(X + 3 * d, Y)
      ctx.lineTo(X + 3 * d, Y + d)
      ctx.bezierCurveTo(
        X + 2 * d,
        Y + d,
        X + 2 * d,
        Y + 2 * d,
        X + 3 * d,
        Y + 2 * d
      )
      ctx.lineTo(X + 3 * d, Y + 3 * d)
      ctx.lineTo(X, Y + 3 * d)
      ctx.closePath()
      ctx.stroke()
      ctx.fill()

      let cl = this.$refs.puzzleLost
      let cs = this.$refs.puzzleShadow
      let ctl = cl.getContext('2d')
      let cts = cs.getContext('2d')
      let img = new Image()
      img.src = this.imgSrc
      img.onload = () => {
        ctl.drawImage(img, 0, 0, w, h)
      }
      ctl.beginPath()
      ctl.strokeStyle = 'rgba(0,0,0,0)'
      ctl.moveTo(X, Y)
      ctl.lineTo(X + d, Y)
      ctl.bezierCurveTo(X + d, Y - d, X + 2 * d, Y - d, X + 2 * d, Y)
      ctl.lineTo(X + 3 * d, Y)
      ctl.lineTo(X + 3 * d, Y + d)
      ctl.bezierCurveTo(
        X + 2 * d,
        Y + d,
        X + 2 * d,
        Y + 2 * d,
        X + 3 * d,
        Y + 2 * d
      )
      ctl.lineTo(X + 3 * d, Y + 3 * d)
      ctl.lineTo(X, Y + 3 * d)
      ctl.closePath()
      ctl.stroke()
      ctl.shadowBlur = 10
      ctl.shadowColor = 'black'
      ctl.clip()
      cts.beginPath()
      cts.lineWidth = '1'
      cts.strokeStyle = 'rgba(0,0,0,0)'
      cts.moveTo(X, Y)
      cts.lineTo(X + d, Y)
      cts.bezierCurveTo(X + d, Y - d, X + 2 * d, Y - d, X + 2 * d, Y)
      cts.lineTo(X + 3 * d, Y)
      cts.lineTo(X + 3 * d, Y + d)
      cts.bezierCurveTo(
        X + 2 * d,
        Y + d,
        X + 2 * d,
        Y + 2 * d,
        X + 3 * d,
        Y + 2 * d
      )
      cts.lineTo(X + 3 * d, Y + 3 * d)
      cts.lineTo(X, Y + 3 * d)
      cts.closePath()
      cts.stroke()
      cts.shadowBlur = 20
      cts.shadowColor = 'black'
      cts.fill()
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.iy-code {
  background: #fff;
  width: 400px;
  padding: 20px;
  margin: 100px auto;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);
}

.code-pic {
  background: #f7f7f7;
  border-radius: 8px;
  border: 1px solid #ddd;
  padding: 10px;
  width: 365px;
  margin: 0 auto;
  box-sizing: content-box;

  .code-wrap {
    position: relative;
    overflow: hidden;
    height: 200px;
    width: 365px;
  }

  .code-bg {
    height: 100%;
    overflow: hidden;
    position: relative;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }

    .canvas1 {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
    }
  }

  .code-move {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 5;

    .code-move-content {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  .canvas2,
  .canvas3 {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .canvas2 {
    z-index: 22;
  }

  .canvas3 {
    z-index: 33;
  }
}

.code-bar {
  position: relative;
  width: 365px;
  margin: 20px auto 0;
  height: 38px;
  background: #f7f7f7;
  border-radius: 4px;
  border: 1px solid #e9e9e9;

  .cb-text {
    font-size: 12px;
    color: #999;
    text-align: center;
    line-height: 38px;
    user-select: none;
  }

  .cb-btn {
    width: 50px;
    height: 40px;
    position: absolute;
    left: 0;
    top: -1px;
    cursor: move;
    z-index: 2;
    margin-left: -2px;

    &:before {
      content: "";
      position: absolute;
      left: 2px;
      background: #fff url(/static/assist/imgVerArrow.png) no-repeat center;
      right: 2px;
      top: 2px;
      bottom: 2px;
      z-index: 0;
      border-radius: 3px;
    }

    &:after {
      content: "";
      background: linear-gradient(left, #09afdf, #02e3b8);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: -1;
      border-radius: 5px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    }
  }

  .cb-state {
    background: #d0fbee;
    border: 1px solid #75eeca;
    position: absolute;
    top: -1px;
    left: -1px;
    height: 38px;
    color: #00cfbc;
    font-size: 12px;
    line-height: 38px;
    text-align: center;
    border-radius: 5px;
  }

  &.codeError {
    .cb-state {
      background: #fa96a0;
      border-color: #e880a0;
    }

    .cb-btn {
      &:after {
        background: #fd3930;
      }

      &:before {
        background: #fff url(/static/assist/imgVerError.png) no-repeat center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/model/captcha.vue